import React from "react"
import styled from "styled-components"
import FacebookLogo from "../../images/product/facebook-logo.svg"
import TwitterLogo from "../../images/product/twitter-logo.svg"
import { Link } from "gatsby"

import { Container } from "../global"
import { FACEBOOK_PAGE_LINK, TWITTER_PAGE_LINK } from "../../utils"

const Footer = () => (
  <FooterWrapper id="footer">
    <BrandContainer>
      <Logo>Sookind</Logo>
      <AdditionalPageDetailsContainer>
        <span>© 2020 Sookind. All rights reserved</span>
        <span>
          <Link to="/privacy-policy">Privacy Policy</Link>
        </span>
        <span>
          <Link to="/terms-and-conditions">Terms</Link>
        </span>
        <span>
          <Link to="/credits">Credits</Link>
        </span>
      </AdditionalPageDetailsContainer>
    </BrandContainer>
    <SocialMediaButtonsContainer>
      <a href={FACEBOOK_PAGE_LINK} target="_blank" rel="noopener noreferrer">
        <SocialMediaButton src={FacebookLogo} alt="Facebook Logo" />
      </a>
      <a href={TWITTER_PAGE_LINK} target="_blank" rel="noopener noreferrer">
        <SocialMediaButton src={TwitterLogo} alt="Twitter Logo" />
      </a>
    </SocialMediaButtonsContainer>
  </FooterWrapper>
)

const FooterWrapper = styled.footer`
  background-color: white;
  margin: 0;
  padding: 40px 0 40px;
  display: flex;

  @media (max-width: ${props => props.theme.screen.sm}) {
    padding: 20px 0 20px;
  }
`

const Logo = styled.div`
  font-family: ${props => props.theme.font.extrabold};
  ${props => props.theme.font_size.regular};
  color: ${props => props.theme.color.black.regular};
  text-decoration: none;
  letter-spacing: 1px;
  margin: 0;
  display: inline-flex;
  justify-content: start;
  align-items: flex-start;
  position: relative;
  z-index: 9;
  text-decoration: none;
  outline: 0px;

  @media (max-width: ${props => props.theme.screen.sm}) {
    ${props => props.theme.font_size.small};
  }
`

const BrandContainer = styled(Container)`
  position: relative;
  width: 80%;
  /* padding-top: 48px; */
  display: grid;
  grid-template-columns: 1fr;
  align-items: flex-start;

  @media (max-width: ${props => props.theme.screen.sm}) {
    width: 90%;
  }
`

const SocialMediaButtonsContainer = styled(Container)`
  position: relative;
  width: 12%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: flex-end;
  /* width: 8em; */
  padding: 0px 16px 0px 0px;
  @media (max-width: ${props => props.theme.screen.sm}) {
    width: 25%;
  }
`
const SocialMediaButton = styled.img`
  width: 2em;
  align-self: flex-end;
  @media (max-width: ${props => props.theme.screen.sm}) {
    width: 1.5em;
  }
  fill: red;

  &:hover,
  &:focus {
    filter: invert(49%) sepia(75%) saturate(389%) hue-rotate(147deg)
      brightness(91%) contrast(89%);
  }
`
const AdditionalPageDetailsContainer = styled.div`
  display: grid;
  grid-template-columns: 0.9fr repeat(3, 0.4fr);

  @media (max-width: ${props => props.theme.screen.sm}) {
    grid-template-columns: 1fr repeat(3, 0.4fr);
    > span {
      ${props => props.theme.font_size.xxxsmall};
      font-size: 10px;
    }
  }
`
export default Footer
